import { render, staticRenderFns } from "./facturaDeCompra.crear.vue?vue&type=template&id=b218f9fe"
import script from "./facturaDeCompra.crear.vue?vue&type=script&lang=js"
export * from "./facturaDeCompra.crear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports